var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vcv-tiptap",class:{ error: _vm.isEmpty }},[_c('menu-bar',{attrs:{"editor":_vm.editor,"variables":_vm.variables,"is-lite":_vm.isLite}},[_c('template',{slot:"toolbar"},[_vm._t("toolbar")],2)],2),_vm._v(" "),_c('editor-content',{attrs:{"editor":_vm.editor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }